<template>
  <div class="bto-sb-widget bto-sb-category-filter">
    <div class="bto-sb-widget-content">
      <ul>
        <li
          v-for="(market, idx) in markets"
          :key="idx"
          :class="{'bto-sb-category-filter-active': market.tabs.map(m => Number.parseInt(m.id, 10)).includes(singleMarketSelected)}"
        >
          <div class="bto-sb-form-select">
            <select @change="marketTabSelect($event, idx)" v-model="dropdowns[idx]">
              <option selected disabled :value="null" v-if="dropdowns[idx] === null">
                {{market.name}}
              </option>
              <option
                v-for="(tab, idx) in market.tabs"
                :key="idx"
                :value="tab.id"
              >
                {{tab.name}}
              </option>
            </select>
            <div class="bto-sb-form-select-arrow"></div>
          </div>
        </li>
        <li v-if="singleMarketSelected">
          <a
            href="javascript:void(0);"
            class="bto-sb-form-btn"
            @click="clearMarketFilter()"
          >
            {{t('W.clearFilter')}}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CategoryMarketSelectorComponent',
    props: {
      markets: {
        type: Array,
        required: true,
        default: () => [],
      },
      sportName: {
        type: String,
        required: true,
        default: '',
      },
      singleMarketSelected: {
        required: true,
        default: null,
      },
      marketTabSelectHandler: {
        type: Function,
        required: true,
        default: () => {},
      }
    },
    data() {
      return {
        dropdowns: [],
      };
    },
    created() {
      this.$nextTick(() => this.resetDropdowns());
    },
    watch: {
      markets() {
        this.resetDropdowns();
      },
      singleMarketSelected() {
        if (this.singleMarketSelected === null) {
          this.resetDropdowns();
        }
      },
    },
    methods: {
      marketTabSelect(event, idx) {
        this.dropdowns = this.markets.map((m, i) =>
          idx === i ? event.target.value : null
        );

        let marketTabId = Number.parseInt(event.target.value);
        this.marketTabSelectHandler(marketTabId);
      },
      clearMarketFilter() {
        this.resetDropdowns();
        this.marketTabSelectHandler(null);
      },
      resetDropdowns() {
        this.dropdowns = new Array(this.markets.length).fill(null);
      },
    },
  };
</script>
